module.exports = __webpack_public_path__ + "img/Doctor.3f7bc2cb.svg";